const ScheduleDrawerHeader = [
  {
    group: "Pedido",
    columns: [
      {
        name: "Id",
        id: "pedido-id",
        show: false,
      },
      {
        name: "Centro",
        id: "pedido-centro",
        show: true,
      },

      {
        name: "Fornecedor",
        id: "pedido-fornecedor",
        show: false,
      },
      {
        name: "Setor",
        id: "pedido-setor",
        show: true,
      },
      {
        name: "Código",
        id: "pedido-codigo",
        show: true,
      },
      {
        name: "Produto",
        id: "pedido-produto",
        show: true,
      },
      {
        name: "Pedido",
        id: "pedido-pedido",
        show: true,
      },
    ],
  },
  {
    group: "Quantidade",
    columns: [
      {
        name: "Qtde Total",
        id: "quantidade-total",
        show: true,
      },
      {
        name: "Qtde Entregue",
        id: "quantidade-entregue",
        show: true,
      },
      {
        name: "Qtde Pendente",
        id: "quantidade-pendente",
        show: true,
      },
      {
        name: "Qtde Agendada",
        id: "quantidade-agendada",
        show: true,
      },
    ],
  },
  {
    group: "Data",
    columns: [
      {
        name: "Agendada",
        id: "data-agendada",
        show: true,
      },
      {
        name: "Data Prevista",
        id: "data-prevista",
        show: true,
      },
    ],
  },
];

export default ScheduleDrawerHeader;
